import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Checkbox from "material-ui/Checkbox";

const styles = () => ({
  entry: {
    width: '100%',
    marginTop: '8px',
    display: 'inline-flex',
    alignItems: 'flex-start',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  checkboxContainer: {
    marginTop: '5px',
  },

  text: {
    marginLeft: '10px',
    cursor: 'pointer',
  },

  error: {
    marginBottom: 10,
    fontSize: 12,
    color: '#F03A47',
  },
});

class AnswerCheckbox extends React.Component {
  render() {
    const { classes, set, options, select, error, errorText } = this.props;
    return (
      <div className={classes.checkboxContainer}>
        {options.map((option, i) => (
          <div key={i} className={classes.entry}>
            <Checkbox
              color="primary"
              checked={set.includes((option.value).toString())}
              style={{
                width: '20px',
                height: '20px',
              }}
              value={(option.value).toString()}
              onChange={() => select((option.value).toString())}
            />
            <Typography
              variant="subheading"
              className={classes.text}
              onClick={() => select((option.value).toString())}
            >
              {option.text}
            </Typography>
          </div>
        ))}
        {error && (
          <Typography variant="subheading" className={classes.error}>{errorText}</Typography>
        )}
      </div>
    )
  }
}

AnswerCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  set: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  select: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
};

export default withStyles(styles)(AnswerCheckbox);



// WEBPACK FOOTER //
// ./src/components/Questionnaire/parts/AnswerCheckbox.jsx